export default {
  // 用户信息
  userInfo: {},
  token: '',
  commonbg: '../../../static/img/summary/commonbg.png',
  defaultImg: '../../../../static/img/news/lmdefault.jpg'
};



// WEBPACK FOOTER //
// ./src/store/states/index.js